module.exports = __webpack_public_path__ + "static/media/jayesh.39735a06.png";